import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import ConnectedCampusPage from '../pages/CampusPage';
import ConnectedCheckEligiblePage from '../pages/CheckEligiblePage';
import ConnectedCitizenshipPage from '../pages/CitizenshipPage';
import ConnectedClassUnderReviewPage from '../pages/ClassUnderReviewPage';
import ConnectedConfirmedJobOfferPage from '../pages/ConfirmedJobOfferPage';
import ConnectedContinuePage from '../pages/ContinuePage';
import ConnectedCoursePage from '../pages/CoursePage';
import ConnectedCourseUnderReviewPage from '../pages/CourseUnderReviewPage';
import ConnectedCreditCardDebtPage from '../pages/CreditCardDebtPage';
import ConnectedCurrentAddressPage from '../pages/CurrentAddressPage';
import ConnectedCurrentlyEmployedPage from '../pages/CurrentlyEmployedPage';
import ConnectedCurrentResidenceDatesPage from '../pages/CurrentResidenceDatesPage';
import ConnectedCurrentSalary from '../pages/CurrentSalaryPage';
import ConnectedDateOfBirthPage from '../pages/DateOfBirthPage';
import ConnectedDeclarationPage from '../pages/DeclarationPage';
import ConnectedDepositPage from '../pages/DepositPage';
import ConnectedEligiblePage from '../pages/EligiblePage';
import ConnectedEmployerCountryPage from '../pages/EmployerCountryPage';
import ConnectedEmployerPage from '../pages/EmployerPage';
import ConnectedEmploymentDates from '../pages/EmploymentDatesPage';
import ConnectedErrorPage from '../pages/ErrorPage';
import ConnectedEstimatedAssetsPage from '../pages/EstimatedAssetsPage';
import ConnectedFrenchRegulationBlockPage from '../pages/FrenchRegulationBlockPage';
import ConnectedFullTimeEmploymentDatesPage from '../pages/FullTimeEmploymentDatesPage';
import ConnectedFullTimeJobPage from '../pages/FullTimeJobPage';
import ConnectedFutureSalary from '../pages/FutureSalaryPage';
import ConnectedGenderPage from '../pages/GenderPage';
import ConnectedHabitualResidenceCountryPage from '../pages/HabitualResidenceCountryPage';
import ConnectedHasDebtPage from '../pages/HasDebtPage';
import ConnectedIneligiblePage from '../pages/IneligiblePage';
import ConnectedLoanAmountPage from '../pages/LoanAmountPage';
import ConnectedLoanContextPage from '../pages/LoanContextPage';
import NotFoundPage from '../pages/NotFound';
import ConnectedOtherFundsPage from '../pages/OtherFundsPage';
import ConnectedPassportNamePage from '../pages/PassportNamePage';
import ConnectedPeriodRequestPage from '../pages/PeriodRequestPage';
import ConnectedPreviousEducationPage from '../pages/PreviousEducationPage';
import ConnectedPreviousProdigyLoanAmountPage from '../pages/PreviousProdigyLoanAmountPage';
import ConnectedPreviousProdigyLoanPage from '../pages/PreviousProdigyLoanPage';
import ConnectedPreviousResidencePage from '../pages/PreviousResidencePage';
import ConnectedProgrammeCostsPage from '../pages/ProgrammeCostsPage';
import ConnectedProgrammeLengthPage from '../pages/ProgrammeLengthPage';
import ConnectedProvisionalOfferPage from '../pages/ProvisionalOfferPage';
import ConnectedReferralCodePage from '../pages/ReferralCodePage';
import ConnectedReloadPage from '../pages/ReloadPage';
import ConnectedRemainingPeriodsPage from '../pages/RemainingPeriodsPage';
import ConnectedResidenceCountryPage from '../pages/ResidenceCountryPage';
import ConnectedResidenceStatePage from '../pages/ResidenceStatePage';
import ConnectedResourceNotFoundPage from '../pages/ResourceNotFoundPage';
import RestartInPlatformPage from '../pages/RestartInPlatformPage';
import ConnectedSavePage from '../pages/SavePage';
import ConnectedSchoolPage from '../pages/SchoolPage';
import ConnectedSecondAddressPage from '../pages/SecondAddressPage';
import ConnectStudyStartDateSubmittedPage from '../pages/StudyStartDateSubmittedPage';
import ConnectedSubmitPage from '../pages/SubmitPage';
import ConnectedSuccessPage from '../pages/SuccessPage';
import ConnectedTestTakenPage from '../pages/TestTakenPage';
import ConnectedThirdAddressPage from '../pages/ThirdAddressPage';
import ConnectedUnpaidTuitionCostPage from '../pages/UnpaidTuitionCostPage';
import ConnectedUnrecoverableErrorPage from '../pages/UnrecoverableErrorPage';
import ConnectedUnsupportedSchoolPage from '../pages/UnsupportedSchoolPage';
import ConnectedWhereToStudyPage from '../pages/WhereToStudyPage';
import ConnectedWorkExperiencePage from '../pages/WorkExperiencePage';

import PrivateRoute from './PrivateRoute';

const Routes = (
  <Switch>
    <Route exact path="/">
      <Redirect to="/referral-code" />
    </Route>
    <PrivateRoute path="/continue/:applicationId" component={ConnectedContinuePage} />
    <PrivateRoute path="/reload" component={ConnectedReloadPage} />
    <PrivateRoute exact path="/referral-code" component={ConnectedReferralCodePage} />
    <PrivateRoute exact path="/residence-state" component={ConnectedResidenceStatePage} />
    <PrivateRoute exact path="/residence-country" component={ConnectedResidenceCountryPage} />
    <PrivateRoute
      exact
      path="/current-residence-dates"
      component={ConnectedCurrentResidenceDatesPage}
    />
    <PrivateRoute exact path="/previous-residence" component={ConnectedPreviousResidencePage} />
    <PrivateRoute exact path="/citizenship" component={ConnectedCitizenshipPage} />
    <PrivateRoute exact path="/school" component={ConnectedSchoolPage} />
    <PrivateRoute exact path="/unsupported-school" component={ConnectedUnsupportedSchoolPage} />
    <PrivateRoute
      exact
      path="/study-start-date-submitted"
      component={ConnectStudyStartDateSubmittedPage}
    />
    <PrivateRoute exact path="/campus" component={ConnectedCampusPage} />
    <PrivateRoute
      exact
      path="/french-regulation-block"
      component={ConnectedFrenchRegulationBlockPage}
    />
    <PrivateRoute exact path="/course" component={ConnectedCoursePage} />
    <PrivateRoute exact path="/course-under-review" component={ConnectedCourseUnderReviewPage} />
    <PrivateRoute exact path="/programme-length" component={ConnectedProgrammeLengthPage} />
    <PrivateRoute exact path="/programme-costs" component={ConnectedProgrammeCostsPage} />
    <PrivateRoute exact path="/period-request" component={ConnectedPeriodRequestPage} />
    <PrivateRoute exact path="/unpaid-tuition-cost" component={ConnectedUnpaidTuitionCostPage} />
    <PrivateRoute exact path="/date-of-birth" component={ConnectedDateOfBirthPage} />
    <PrivateRoute exact path="/eligible" component={ConnectedEligiblePage} />
    <PrivateRoute exact path="/ineligible" component={ConnectedIneligiblePage} />
    <PrivateRoute exact path="/test-taken" component={ConnectedTestTakenPage} />
    <PrivateRoute exact path="/employer-country" component={ConnectedEmployerCountryPage} />
    <PrivateRoute exact path="/confirmed-job-offer" component={ConnectedConfirmedJobOfferPage} />
    <PrivateRoute exact path="/future-salary" component={ConnectedFutureSalary} />
    <PrivateRoute exact path="/work-experience" component={ConnectedWorkExperiencePage} />
    <PrivateRoute exact path="/currently-employed" component={ConnectedCurrentlyEmployedPage} />
    <PrivateRoute exact path="/current-salary" component={ConnectedCurrentSalary} />
    <PrivateRoute exact path="/employer" component={ConnectedEmployerPage} />
    <PrivateRoute exact path="/estimated-assets" component={ConnectedEstimatedAssetsPage} />
    <PrivateRoute exact path="/has-debt" component={ConnectedHasDebtPage} />
    <PrivateRoute exact path="/credit-card-debt" component={ConnectedCreditCardDebtPage} />
    <PrivateRoute exact path="/previous-education" component={ConnectedPreviousEducationPage} />
    <PrivateRoute exact path="/successful-submission" component={ConnectedSuccessPage} />
    <PrivateRoute exact path="/loan-context" component={ConnectedLoanContextPage} />
    <PrivateRoute exact path="/loan-amount" component={ConnectedLoanAmountPage} />
    <PrivateRoute exact path="/remaining-periods" component={ConnectedRemainingPeriodsPage} />
    <PrivateRoute exact path="/declaration" component={ConnectedDeclarationPage} />
    <PrivateRoute exact path="/passport-name" component={ConnectedPassportNamePage} />
    <PrivateRoute exact path="/current-address" component={ConnectedCurrentAddressPage} />
    <PrivateRoute exact path="/second-address" component={ConnectedSecondAddressPage} />
    <PrivateRoute exact path="/third-address" component={ConnectedThirdAddressPage} />
    <PrivateRoute exact path="/gender" component={ConnectedGenderPage} />
    <PrivateRoute exact path="/full-time-job" component={ConnectedFullTimeJobPage} />
    <PrivateRoute exact path="/other-funds" component={ConnectedOtherFundsPage} />
    <PrivateRoute exact path="/deposit" component={ConnectedDepositPage} />
    <PrivateRoute exact path="/employment-dates" component={ConnectedEmploymentDates} />
    <PrivateRoute exact path="/where-to-study" component={ConnectedWhereToStudyPage} />
    <PrivateRoute exact path="/check-eligible" component={ConnectedCheckEligiblePage} />
    <PrivateRoute
      exact
      path="/habitual-residence"
      component={ConnectedHabitualResidenceCountryPage}
    />
    <PrivateRoute
      exact
      path="/full-time-employment-dates"
      component={ConnectedFullTimeEmploymentDatesPage}
    />
    <PrivateRoute exact path="/submit" component={ConnectedSubmitPage} />
    <PrivateRoute
      exact
      path="/previous-prodigy-loan"
      component={ConnectedPreviousProdigyLoanPage}
    />
    <PrivateRoute
      exact
      path="/previous-prodigy-loan-amount"
      component={ConnectedPreviousProdigyLoanAmountPage}
    />
    <PrivateRoute exact path="/save-eligibility" component={ConnectedSavePage} />
    <PrivateRoute
      exact
      path="/provisional-offer/:applicationId"
      component={ConnectedProvisionalOfferPage}
    />
    <PrivateRoute exact path="/save-personal-info" component={ConnectedSavePage} />
    <PrivateRoute exact path="/save-personal-finances" component={ConnectedSavePage} />
    <PrivateRoute exact path="/save-previous-education" component={ConnectedSavePage} />
    <PrivateRoute exact path="/save-employment" component={ConnectedSavePage} />
    <PrivateRoute exact path="/save-loan-details" component={ConnectedSavePage} />
    <Route exact path="/error" component={ConnectedErrorPage} />
    <Route exact path="/class-under-review" component={ConnectedClassUnderReviewPage} />
    <Route exact path="/unrecoverable-error" component={ConnectedUnrecoverableErrorPage} />
    <Route exact path="/platform-restart" component={RestartInPlatformPage} />
    <Route exact path="/resource-not-found" component={ConnectedResourceNotFoundPage} />
    <Route component={NotFoundPage} />
  </Switch>
);

export default Routes;
